import { AppThunk } from '../../../store/rootReducer';
import { trackStopRuler } from '../../analytics/thunks/track-stop-ruler.thunk';
import { trackUseRuler } from '../../analytics/thunks/track-use-ruler.thunk';
import { setActiveTool } from '../../tool/actions/tool.actions';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { isRestingStripSelector } from '../../ecg/selectors/ecg.selectors';
import { getApplicationPath } from '../../ecg/utils/application-path.utils';

export const toggleRuler = (): AppThunk => (dispatch, getState) => {
  const isRestingStrip = isRestingStripSelector(getState());
  const path = getApplicationPath(window.location);
  const isZoomNoise = path === 'zoom-noise';
  const isResting = isRestingStrip && (path === 'resting' || path === 'zoom');
  const rulerTool = isZoomNoise || isResting ? Tool.ruler2d : Tool.ruler;
  const isRulerActive = isToolActiveSelector(
    Tool.ruler,
    Tool.rulerAnchored,
    Tool.ruler2d,
  )(getState());
  dispatch(
    isRulerActive ? trackStopRuler('keyboard') : trackUseRuler('keyboard'),
  );
  dispatch(
    setActiveTool({
      tool: isRulerActive ? null : rulerTool,
      meta: { history: false },
    }),
  );
};
